import Module from "utilities/global/sparta-module-utility/6.2.5/js/sparta-module-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.2/js/ah-caw-events-master-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import _ from "vendor/lodash";
import Handlebars from "vendor/handlebars";
import Templates from "global/sparta-templates-utility";
import "css!modules/login/ah-page-title-module/7.0.1/css/ah-page-title-module.scss.css";

const scope = {};
class ahPageTitleModuleTemplates extends Templates {
  constructor() {
    super();
    scope.templates = [{ name: 'ah-page-title-module', precompiled: {"1":function(container,depth0,helpers,partials,data) {
    return "class=\"columns small-6\"";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "      <div class=\"columns small-6\">\n        <img itemprop=\"logo\" id=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.logo : stack1)) != null ? stack1.id : stack1), depth0))
    + "\" class=\"flagscape-logo\" id=\"boaFlagscapeLogo\" alt=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.logo : stack1)) != null ? stack1.title : stack1), depth0))
    + "\" src=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.logo : stack1)) != null ? stack1.src : stack1), depth0))
    + "\" />\n      </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "      <div id=\"BOL-logo-content\" class=\"columns small-3 hidden\">\n        <img itemprop=\"logo\" id=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.bol : stack1)) != null ? stack1.id : stack1), depth0))
    + "\" class=\"\" id=\"boaFlagscapeLogo\" alt=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.bol : stack1)) != null ? stack1.title : stack1), depth0))
    + "\" src=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.bol : stack1)) != null ? stack1.src : stack1), depth0))
    + "\" />\n      </div>\n      <div id=\"OLB-logo-content\" class=\"columns small-3 hidden\">\n        <img itemprop=\"logo\" id=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.logo : stack1)) != null ? stack1.id : stack1), depth0))
    + "\" class=\"flagscape-logo\" id=\"boaFlagscapeLogo\" alt=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.logo : stack1)) != null ? stack1.title : stack1), depth0))
    + "\" src=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.logo : stack1)) != null ? stack1.src : stack1), depth0))
    + "\" />\n      </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.lambda, alias3=container.escapeExpression;

  return "\n\n\n<div id=\"ahPageTitleContainer\" class=\"spa-collapse-large spa-collapse-small full-width hidden clearfix\">\n  <div class=\"row title-bar\">\n    <div id=\"title-content\" "
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.showflagscapelogo : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n        <h3 class=\"regular-text container-pad "
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.basecolor : stack1), depth0))
    + "-bar cnx-regular title-wrapper\" role=\"heading\" aria-level=\"3\">"
    + alias3(alias2(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.text : stack1)) != null ? stack1["caw-title"] : stack1), depth0))
    + "</h3>\n        <h3 class=\"important-text hidden container-pad "
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.basecolor : stack1), depth0))
    + "-bar cnx-regular title-wrapper\" role=\"heading\" aria-level=\"1\">"
    + alias3(alias2(((stack1 = ((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.text : stack1)) != null ? stack1["important-notice-title"] : stack1), depth0))
    + "</h3>\n    </div>\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.showflagscapelogo : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.uselogo : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <div class=\"clearfix\"></div>\n  </div>\n</div>\n";
},"useData":true} }];
  }

  get templates() { return scope.templates; }
  get(templateName) {
    return Handlebars.template(_.find(this.templates, {
      name: templateName
    }).precompiled);
  }
};

export default new ahPageTitleModuleTemplates();
